export default __webpack_public_path__ + "static/WC-4-2099fe4bf38179528b284e8d37674de2.png";